"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.75 13a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5m0 2.5a.5.5 0 0 0-.5.5v1.25H16a.5.5 0 0 0 0 1h1.25v1.25a.5.5 0 0 0 1 0v-1.25h1.25a.5.5 0 0 0 0-1h-1.25V16a.5.5 0 0 0-.5-.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.5 3.5c.972 0 2.353.118 3.489 1.04 1.085.882 1.845 2.412 1.932 4.96h1.934a1.5 1.5 0 0 1 1.486 1.703l-.154 1.124a5.945 5.945 0 0 0-7.05 9.173H5.373a1.5 1.5 0 0 1-1.486-1.297l-1.227-9A1.5 1.5 0 0 1 4.146 9.5h1.933c.088-2.536.849-4.064 1.932-4.948 1.135-.926 2.515-1.052 3.49-1.052m-5.43 8.43a.5.5 0 0 0 1 0V10.5h-1zM11.5 4.5c-.914 0-2 .126-2.857.826-.785.64-1.476 1.845-1.563 4.174h8.84c-.086-2.342-.778-3.546-1.562-4.184C13.5 4.62 12.418 4.5 11.5 4.5",
    clipRule: "evenodd"
  })]
}), 'OrderAndRegisterFilled');
//# sourceMappingURL=index.js.map